import { render, staticRenderFns } from "./ServicesTypeFloatBtns.vue?vue&type=template&id=018fdeb2&"
import script from "./ServicesTypeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./ServicesTypeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports